interface State {
  countryList: any[];
  prefixList: any[];
  prefixCount: number;
}

const initialState: State = {
  countryList: [],
  prefixList: [],
  prefixCount: 0,
};

export const countryReducer = (
  state: State = initialState,
  action: any,
): State => {
  switch (action.type) {
    case "GET_COUNTRY_DATA":
      return {
        ...state,
        countryList: action.payload,
      };
      case "GET_PREFIX_DATA":
      return {
        ...state,
        prefixList:
          action.payload?.page === 1
            ? action.payload?.list || []
            : [...state.prefixList, ...(action.payload?.list || [])],
        prefixCount: action.payload?.count || 0,
      };

    case "CLEAR_PREFIX_DATA":
      return {
        ...state,
        prefixList: [],
        prefixCount: 0,
      };

    default:
      return state;
  }
};
